import { Link } from 'react-router-dom';
import type { ProjectListItem } from '../lib/projects';
import { formatDate } from '../lib/format';
import { StatusBadge } from './StatusBadge';

interface ProjectHeaderProps {
  project: ProjectListItem;
}

export function ProjectHeader({ project }: ProjectHeaderProps) {
  return (
    <div className={`project-header status-strip-${project.status}`} style={{ background: '#fff', borderRadius: 10, border: '1px solid var(--color-border)', padding: '20px 24px', marginBottom: 20 }}>
      <div className="ph-top" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16, gap: 16 }}>
        <div>
          <div className="ph-title" style={{ fontSize: 20, fontWeight: 700, color: 'var(--color-navy)' }}>{project.title}</div>
          <div className="ph-order" style={{ fontSize: 13, color: 'var(--color-text-soft)', marginTop: 2 }}>
            Auftrag <span style={{ fontFamily: 'monospace', fontWeight: 600 }}>{project.order_number}</span>
            {' '}·{' '}
            <Link to="/projects" style={{ textDecoration: 'underline' }}>Zurück zur Übersicht</Link>
          </div>
        </div>
        <StatusBadge status={project.status} />
      </div>

      <div className="ph-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
        <PhItem label="Bauherr" value={project.client_name} />
        <PhItem label="Architekt / GU" value={project.architect_name} />
        <PhItem label="Projektleiter" value={project.project_manager_name} sub={project.project_manager_abbr} />
        <PhItem label="Bauleiter" value={project.site_manager_name} sub={project.site_manager_abbr} />
        <PhItem label="Auftragsstart" value={formatDate(project.start_date)} />
        <PhItem label="Auftragsende" value={formatDate(project.end_date)} />
      </div>

      {project.description && (
        <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px solid var(--color-border-soft)', fontSize: 13, color: 'var(--color-text-strong)' }}>
          <div style={{ fontWeight: 600, color: 'var(--color-text-muted)', marginBottom: 4 }}>
            Beschreibung
          </div>
          <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.55 }}>{project.description}</div>
        </div>
      )}

      {project.notes && (
        <div style={{ marginTop: 14, paddingTop: 14, borderTop: '1px solid var(--color-border-soft)', fontSize: 13, color: 'var(--color-text-strong)' }}>
          <span style={{ fontWeight: 600, color: 'var(--color-text-muted)' }}>Bemerkungen: </span>
          {project.notes}
        </div>
      )}
    </div>
  );
}

function PhItem({ label, value, sub }: { label: string; value: string | null; sub?: string | null }) {
  return (
    <div className="ph-item">
      <label style={{ fontSize: 10, fontWeight: 600, color: 'var(--color-text-soft)', textTransform: 'uppercase', letterSpacing: 0.4, display: 'block', marginBottom: 3 }}>{label}</label>
      <span style={{ fontSize: 13, color: 'var(--color-text)', fontWeight: 500 }}>
        {value ?? '—'}
        {sub ? <span style={{ color: 'var(--color-text-soft)', fontWeight: 400, marginLeft: 6 }}>{sub}</span> : null}
      </span>
    </div>
  );
}
